/**
 * Settings › Configuration — landing for the configuration area. The concrete
 * config resources (Applications, Licenses, Providers, Default pricing) hang
 * off this group in the sidebar user-chip popover; platform-wide default
 * knobs (like log retention) live under Default parameters.
 */

import React from "react";
import { useTranslate } from "react-admin";
import { Box, Typography } from "@mui/material";

const i18nBase = "pages.settings";

export const ConfigurationPage: React.FC = () => {
  const translate = useTranslate();
  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, color: "text.primary", mb: 2, ml: 2 }}
      >
        {translate(`${i18nBase}.configuration`, { _: "Configuration" })}
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", ml: 2 }}>
        {translate(`${i18nBase}.configurationIntro`, {
          _: "Pick a configuration section from the menu.",
        })}
      </Typography>
    </Box>
  );
};

export default ConfigurationPage;
